import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { DialogService } from 'src/app/core/services/dialog.service';
import { FileService } from 'src/app/core/services/file.service';
import { BaseDocumentationsComponent } from '../base/base-documentation.component';


@Component({
    selector: 'app-upload-documents',
    templateUrl: './upload-documents.component.html',
    styleUrls: ['./upload-documents.component.scss'],
    standalone: false
})
export class UploadDocumentsComponent
  extends BaseDocumentationsComponent
  implements OnInit {

  //#region properties
  model: any = {};

  @Input('documentType') documentType;
  @Input('type') authenticateType: string;
  @Input('allowedFiles') allowedFiles: string;


  @Output('items') output_Items = new EventEmitter<any>();

  //#endregion

  constructor(
    protected dialogService: DialogService,
    protected translate: TranslateService,
    protected fileService: FileService,
    protected domSanitizer: DomSanitizer

  ) {
    super(dialogService, translate, fileService, domSanitizer);
  }

  //#region show file after select
  getFile(file) {
    if (!file) {
      this.imgUrl = '';
      this.pdfUrl = '';
      this.model.file = '';
      return;
    }
    this.onFileChanged(file);

    if (this.authenticateType == 'user') {
      this.getUserDocumentationTypesId(this.model, this.documentType);
      this.output_Items.emit(this.model);
    } else if (this.authenticateType == 'privateNumber') {
      this.getPrivateNumberDocumentationTypesId(this.model, this.documentType);
      this.output_Items.emit(this.model);
    } else {
      this.getOrganizationDocumentationTypesId(this.model, this.documentType);
      this.output_Items.emit(this.model);
    }


  }

  onFileChanged(file: any) {
    if (file) {
      this.model.fileName = file.name;

      var reader = new FileReader();
      if (file.type != 'application/pdf')
        reader.onload = (event: any) => {
          this.imgUrl = event.target.result;
          this.pdfUrl = null;
        };
      else if (file.type == 'application/pdf') {
        this.pdfUrl = 'assets/media/svg/files/pdf.svg';
        this.imgUrl = null;
      }
      reader.readAsDataURL(file);
      this.handleFileSelect(file);
    }
  }
  handleFileSelect(file) {
    if (file) {
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    let stringImage = btoa(binaryString);
    this.model.file = stringImage;
  }

  //#endregion


  //#region set document types
  getOrganizationDocumentationTypesId(model, docType) {
    model.organizationDocument = docType.key;
  }

  getUserDocumentationTypesId(model, docType) {
    model.userDocument = docType.key;
  }

  getPrivateNumberDocumentationTypesId(model, docType) {
    model.privateNumberPurchaseDocument = docType.key;
  }
  //#endregion


}
